export class MainMenuController {
  private readonly burgerMenu = '.js-burger';
  private readonly navList = '.js-navList';
  private readonly fistLink = '.js-firstLinks';
  private readonly backLink = 'js-linksBack';
  private readonly openMenusClass = 'openSubMenus';
  private readonly mainMenuMobileHidden = 'nav__list--invisible';
  private readonly svgBackLinkText = 'slider-back';
  private openSubmenuArray: any[] = [];
  private mobileViewport = 992;
  private burgerRef: any = document.querySelector(this.burgerMenu);
  private navListRef: HTMLElement | null = document.querySelector(this.navList);
  private firstLinksRef = document.querySelectorAll(this.fistLink);

  constructor() {
    this.burgerRef?.addEventListener('click', this.burgerToggle);
    window.addEventListener('resize', () => {
      this.closeAllByResizes();
    });
    if (this.isMobile()) {
      this.firstLinksRef.forEach(el => el.addEventListener('click', this.openSubmenu));
    }
  }

  burgerToggle = (e) => {
    if (e.target.checked) {
      if (this.navListRef) {
        this.navListRef.classList.remove(this.mainMenuMobileHidden);
      }
    }
    if (!e.target.checked) {
      if (this.navListRef) {
        this.navListRef.classList.add(this.mainMenuMobileHidden);
        this.closeAllSubMenus();
      }
    }
  }

  openSubmenu = (e) => {
    e.stopPropagation();
    const currentElement = e.currentTarget;
    const backSVG = e.target.textContent === this.svgBackLinkText;
    if (e.target.tagName === 'A') return;
    if (e.target.classList.contains(this.backLink) || backSVG) {
      currentElement.classList.remove(this.openMenusClass);
    } else currentElement.classList.add(this.openMenusClass);

    if (currentElement) {
      this.openSubmenuArray.push(currentElement);
    }
  }

  closeAllSubMenus() {
    this.openSubmenuArray.map(el => {
      el.classList.remove(this.openMenusClass);
    });
    this.openSubmenuArray = [];
  }

  isMobile() {
    return window.innerWidth < this.mobileViewport;
  }

  closeAllByResizes() {
    const burger = this.burgerRef?.firstChild;
    if (burger.checked) {
      burger.checked = false;
      if (this.navListRef) {
        this.navListRef.classList.add(this.mainMenuMobileHidden);
      }
    }
    if (this.isMobile()) {
      this.firstLinksRef.forEach(el => el.addEventListener('click', this.openSubmenu));
    } else {
      this.firstLinksRef.forEach(el => el.removeEventListener('click', this.openSubmenu));
    }
    this.closeAllSubMenus();
  }
}
